import styled, { css } from 'styled-components';
import { DragDropContext, Droppable } from 'react-beautiful-dnd';
import { ScrollContainer } from 'foundations-components/transitional/components/ScrollContainer';
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
const CSSVariables = styled.div.withConfig({
  displayName: "ViewTabsContainer__CSSVariables",
  componentId: "sj5b2v-0"
})(({
  theme
}) => {
  return css(["--view-tabs-gutter:0;--view-tabs-border-color:", ";--view-tabs-border-color-alternate:", ";--view-tabs-border-color-unset:", ";--view-tabs-border-width:", ";--view-tabs-active-bg-color:", ";--view-tabs-inactive-bg-color:", ";--view-tabs-tab-height-px:40px;--view-tabs-tab-padding:", ";--view-tabs-tab-min-width:100px;--view-tabs-tab-max-width:450px;"], theme.color['border-core-default'], theme.color['fill-accent-blue-default'], theme.color['border-core-on-fill-default'], theme.borderWidth['100'], theme.color['fill-surface-default'], theme.color['fill-surface-raised'], theme.space['400']);
});
const StyledTabs = styled.div.withConfig({
  displayName: "ViewTabsContainer__StyledTabs",
  componentId: "sj5b2v-1"
})(["display:grid;grid-gap:calc(var(--view-tabs-gutter) / 2);grid-template-rows:minmax(var(--view-tabs-tab-height-px),1fr);grid-auto-flow:column;grid-auto-columns:minmax( var(--view-tabs-tab-min-width),var(--view-tabs-tab-max-width) );grid-template-columns:repeat( auto-fill,minmax(var(--view-tabs-tab-min-width),var(--view-tabs-tab-max-width)) );grid-column:1 / -1;scrollbar-width:none;padding-bottom:0;&::-webkit-scrollbar{display:none;}"]);
const CustomScrollContainer = styled.div.withConfig({
  displayName: "ViewTabsContainer__CustomScrollContainer",
  componentId: "sj5b2v-2"
})(["height:100%;width:100%;overflow-x:auto;position:relative;padding-bottom:0;"]);
export const ViewTabsContainer = ({
  children,
  onReorder,
  containerRef
}) => {
  return /*#__PURE__*/_jsx(CSSVariables, {
    children: /*#__PURE__*/_jsx(DragDropContext, {
      onDragEnd: onReorder,
      children: /*#__PURE__*/_jsx(Droppable, {
        droppableId: "droppable-1",
        type: "VIEWS_TAB",
        direction: "horizontal",
        children: provided => {
          //this function allows us to intercept scrollElementRef and pass it along to other components above the tree
          //this is used for scrolling the active tab into view
          const scrollElementRef = el => {
            containerRef(el);
            provided.innerRef(el);
          };
          return /*#__PURE__*/_jsx(ScrollContainer, {
            ScrollContainer: CustomScrollContainer,
            scrollElementRef: scrollElementRef,
            "data-rbd-droppable-context-id": provided.droppableProps['data-rbd-droppable-context-id'],
            "data-rbd-droppable-id": provided.droppableProps['data-rbd-droppable-id'],
            children: /*#__PURE__*/_jsxs(StyledTabs, {
              "data-test-id": "view-tabs-container",
              role: "tablist",
              children: [children, provided.placeholder]
            })
          });
        }
      })
    })
  });
};